export default __webpack_public_path__ + "static/media/DNo.36-3.302c12f4.jpg";